<script>
import layout from '@src/mixins/layout.vue'
import { authService } from '@/src/services/safehaven/AuthService'

export default {
  mixins: [layout],
  data() {
    return {
      org: null,
    }
  },
  computed: {
    showLogo() {
      return this.$route?.meta.showLogo
    },
    signUpContainerWidth() {
      if (this.$route.meta.signup) {
        return this.$style.signUpContainer
      } else if (this.$route.meta.independent) {
        return this.$style.indepedentContainer
      } else {
        return this.$style.innerContainer
      }
    },
    displayBack() {
      return this.$route?.meta.accessCode || this.$route?.meta.codeRetrieval
    },
  },
  mounted() {
    this.getOrgDetails()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getOrgDetails() {
      const orgName = this.$route.params.clientId
        ? this.$route.params.clientId.toLowerCase()
        : 'healthbook'
      authService.getLogo(orgName).then(
        (res) => {
          this.org = res.data
          localStorage.setItem('organisationDetails', JSON.stringify(res.data))
          const favicon = document.getElementById('favicon')
          if (favicon) favicon.href = this.org.favicon_url
        },
        (err) => {
          if (
            err.response?.data &&
            err.response.data.org === 'Organization not found'
          ) {
            this.$router.push({
              name: '404',
              params: { clientId: this.$route.params.clientId },
            })
          }
        }
      )
    },
  },
}
</script>

<template>
  <v-container
    id="safehaven"
    fluid
    :class="showLogo ? $style.container : $style.welcomeContainer"
    :fill-height="!notDesktop ? true : false"
  >
    <div :class="signUpContainerWidth">
      <div v-if="displayBack" class="pa-3">
        <a class="clickable primary--text hrRouterLinkText" @click="goBack"
          >Back</a
        >
      </div>

      <div v-if="showLogo && org" class="mt-1 pt-4" align="center">
        <img :class="$style.logo" :src="org.logo_url" />
      </div>
      <div>
        <slot />
      </div>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.innerContainer {
  width: 35%;
  margin: auto;
  background-color: white;
  border-radius: 9px;
}

.signUpContainer {
  width: 50%;
  margin: auto;
  background-color: white;
  border-radius: 9px;
}

.indepedentContainer {
  width: 70%;
  margin: auto;
  border-radius: 9px;
}

.container {
  width: 100%;
  height: 100%;
  padding: 4%;
  margin: auto;
  overflow: hidden;
  background-image: url('~@assets/images/safehaven/Background-Blue-Signin.jpg');
}

.welcomeContainer {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  background-image: url('~@assets/images/safehaven/Background-Blue-Signin.jpg');
}

.logo {
  width: 60%;
  height: auto;
}

@media screen and (max-width: 600px) {
  .innerContainer,
  .signUpContainer {
    width: 100%;
    margin: 0;
    border-radius: 0;
  }

  .container,
  .welcomeContainer {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: white;
    background-image: none;
  }
}

@media screen and (min-width: 601px) and (max-width: 1080px) {
  .innerContainer,
  .signUpContainer {
    width: 46%;
  }
}
</style>

<style scoped>
.hrRouterLinkText {
  font-size: 14px !important;
}
</style>
